/**
 * Utilitários para preservar parâmetros UTM.
 *
 * As UTMs da primeira visita (ex.: vindas de um anúncio) são salvas no localStorage.
 * Quando a URL atual não tem UTM (refresh, retorno direto, redirect pós-checkout,
 * TrialGuard), usamos as salvas. Se a URL tiver UTM nova, ela sobrescreve a salva
 * (último clique vence).
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'pinkstalker_utms';

function readUtmsFromUrl() {
  const currentUrl = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();
  UTM_KEYS.forEach((key) => {
    const value = currentUrl.get(key);
    if (value && value.trim() !== '') {
      utmParams.append(key, value.trim());
    }
  });
  return utmParams;
}

function readUtmsFromStorage() {
  const utmParams = new URLSearchParams();
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    UTM_KEYS.forEach((key) => {
      if (saved[key]) utmParams.append(key, saved[key]);
    });
  } catch (_) {
    // storage indisponível ou corrompido: segue sem UTM salva
  }
  return utmParams;
}

/**
 * Salva no localStorage as UTMs presentes na URL atual (se houver alguma).
 * Chamar uma vez ao carregar o app.
 */
export function saveUtmsFromUrl() {
  const fromUrl = readUtmsFromUrl();
  if ([...fromUrl.keys()].length === 0) return;
  try {
    const obj = {};
    fromUrl.forEach((value, key) => { obj[key] = value; });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch (_) {
    // storage indisponível: só a URL atual vai funcionar
  }
}

/**
 * UTMs em vigor: as da URL atual ou, se não houver, as salvas da primeira visita.
 * @returns {URLSearchParams}
 */
export function getUtmParams() {
  const fromUrl = readUtmsFromUrl();
  if ([...fromUrl.keys()].length > 0) return fromUrl;
  return readUtmsFromStorage();
}

/**
 * Adiciona as UTMs em vigor a uma URL de destino (checkout).
 * @param {string} baseUrl
 * @returns {string}
 */
export function addUtmsToUrl(baseUrl) {
  const utmString = getUtmParams().toString();
  if (!utmString) return baseUrl;
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${utmString}`;
}
